import React from 'react';
import { Box, Image } from '@hz-design-system/web-ui';

import Classes from './ListingSellerLogo.module.scss';

const ListingSellerLogo = ({ logoUrl }: { logoUrl: string }) => {
  return (
    <Box as="span" name="ListingSellerLogo" className={Classes['listingSellerLogo']}>
      <Image src={logoUrl} alt="logo" fit={true} />
    </Box>
  );
};

export default ListingSellerLogo;
